import React from "react";
import AntdAvatar from 'antd/lib/avatar';
// import { withError, useTracker, TrackEventType, getTrackEventInfo} from '@fishx/tracker';
import { withError} from '@fishx/tracker';

const Avatar = (props) => <AntdAvatar {...props} />
Avatar.displayName = 'Avatar';
export default withError(Avatar);



// WEBPACK FOOTER //
// ./src/components/avatar/index.tsx